export enum InstitutionPricingPlan {
  ESSENTIAL = 'ESSENTIAL',
  LEGACY = 'LEGACY',
  PLUS = 'PLUS',
  PREMIUM = 'PREMIUM',
}
